import React from 'react';
import clsx from 'clsx';

import './index.scss';

const FloatingBanner = ({ value, onChange, checked, label, id }) => {
  return (
    <>
      <div className={clsx('FloatingBanner', { checked })}>
        <div className='banner-input-wrapper'>
          <label htmlFor={id}>
            <span className="">
              <input
                className='banner-input'
                type="radio"
                value={value}
                onChange={onChange}
                checked={checked}
                id={id}
              />
            </span>
            <div className="FloatingBanner.label">
              <span className="">
                {label}
              </span>
            </div>
          </label>
        </div>
      </div>
    </>
  );
};

export default FloatingBanner;